
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campaign-products",
      function () {
        return require("private-next-pages/campaign-products.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campaign-products"])
      });
    }
  